import camelcaseKeys from 'camelcase-keys'
import { Guest } from '@/entities/Guest'
import { Profile } from '@/entities/Profile'
import { getTextValue } from '@/lib/helpers/LocalizedText'

export class ActivityReservation {
  constructor (params = {}) {
    const {
      id,
      activityId,
      type,
      roomId,
      requestedDate,
      requestedTime,
      acceptedDate,
      acceptedTime,
      createdAt,
      status,
      guestId,
      ticketFileId,
      refundTicketFileId,
      orderId,
      pendingOrderId,
      comments,
      reason,
    } = camelcaseKeys(params, { deep: true })
    this.id = id || null
    this.activityId = activityId || null
    this.type = type || null
    this.roomId = roomId || null
    this.requestedDate = requestedDate || null
    this.requestedTime = requestedTime || null
    this.acceptedTime = acceptedTime || null
    this.acceptedDate = acceptedDate || null
    this.createdAt = createdAt || null
    this.status = status || null
    this.guestId = guestId || null
    this.ticketFileId = ticketFileId || null
    this.refundTicketFileId = refundTicketFileId || null
    this.pendingOrderId = pendingOrderId || null
    this.orderId = orderId || null
    this.comments = comments || null
    this.reason = reason || null
  }
}

export class NominalAttendee {
  constructor (params = {}) {
    const { attendeeTypeId, attendeeTypeName, guest } = camelcaseKeys(params)
    this.guest = guest ? {
      ...new Guest(guest),
      profile: new Profile(guest.profile),
    } : null
    this.attendeeTypeId = attendeeTypeId || null
    this.attendeeTypeName = attendeeTypeName ? getTextValue(attendeeTypeName) : null
  }
}

export class NumeralAttendee {
  constructor (params = {}) {
    const { attendeeTypeId, attendeeTypeName, quantity } = camelcaseKeys(params)
    this.attendeeTypeId = attendeeTypeId || null
    this.attendeeTypeName = attendeeTypeName ? getTextValue(attendeeTypeName) : null
    this.quantity = typeof quantity === 'number' ? quantity : null
  }
}
